import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import ConfirmButton from "../Buttons/ConfirmButton";
// import CancelButton from "../../Components/Buttons/CancelButton";
import { withRouter } from "react-router-dom";
// import { addRemoveFavouriteTeacher } from "../../redux/college/college.actions"
import { Icon } from "semantic-ui-react";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import Moment from "react-moment";
import { tagsToArray } from "../../Components-Pages/JobBoard/utils";
import ShareJobListing from "../PopUpForm/ShareJobListing";
import {
  addFavouriteListing,
  removeFavouriteListing,
  updateSimpleQualification,
} from "../../redux/homePage/homePage.actions";
import "./JobListingFull.css";
import ReactTooltip from "react-tooltip";
import { getFullDeliveryModeString } from "../../Helper/JobHelper";
import Modal from "../Modal/Modal";
import CheckableButton from "../CheckableButton/CheckableButton";
import { notify } from "react-notify-toast";
import { API } from "../../API";
const _ = require('lodash');

function JobListingFull(props) {
  const {
    job,
    inst,
    campus,
    isViewAsTeacher,
    isPreview,
    isPublic,
    isFaved,
    isApplied,
    showSharePopup,
    confirmedInterviewTime,
    interviewScheduleInfo,
    isAdmin,
    simpleQualifications,
    isSearchable,
    updateSimpleQualification,
    teacher,
    isCustomer
  } = props;
  //useEffect(() => console.log(campus), []);
  //const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [showPopup, setShowPopup] = useState(false);
  const isOwnListing = job.inst_id === props.institution._id;
  const [showInterviewPopup, setShowInterviewPopup] = useState(false)
  const [confirmedInterview, setConfirmedInterview] = useState(confirmedInterviewTime || null)
  const [interviewTimeID, setInterviewTimeID] = useState('')
  const [simpleQualificationsList, setSimpleQualificationsList] = useState(simpleQualifications || [])
  const [showProgressModal, setShowProgressModal] = useState(false)
  // console.log(interviewScheduleInfo)

  useEffect(async () => {
    if(!simpleQualifications || !simpleQualifications?.length) {
      const resQua = await API.getSimpleQualification();
      const simpleQualifications = resQua?.data?.data
      updateSimpleQualification(simpleQualifications)
      setSimpleQualificationsList(simpleQualifications)
    }
    else {
      setSimpleQualificationsList(simpleQualifications)
    }
  }, [])

  const getTagName = (levelID) => {
		const levelItem = simpleQualificationsList.find(ele => ele._id === levelID)
		return levelItem ? (levelItem?.code ? `${levelItem.title} (${levelItem.code})` : levelItem.title)
			: levelID
	};

  const sendApplication = () => {
    if (isViewAsTeacher || isPublic) {
      // todo: fill out application functionality
      if(getProgress() >= 50) {
        props.sendApplication();
      }
      else {
        setShowProgressModal(true);
      }
    }
  };
  const toggleFavourite = () => {
    if (isFaved) {
      props.removeFavouriteListing(props.job._id);
    } else {
      props.addFavouriteListing(props.job._id);
    }
  };

  const confirmInterviewTime = () => {
    if (interviewTimeID) {
      // console.log(interviewTimeID)
      // Todo: send interview time confirmation
      API.selectInterviewTime(props.job._id, interviewTimeID)
        .then(res => {
          setShowInterviewPopup(false)
          setConfirmedInterview(interviewScheduleInfo.find((schedule) => schedule._id === interviewTimeID))
          notify.show('Interview time confirmed.')
        })
        .catch(err => {
          console.log(err.response)
        })
    } else {
      notify.show('Please choose an interview time.')
    }
  }

  const favHeart = () => {
    return isFaved ? (
      <Icon
        name="heart"
        size="big"
        color="red"
        className="job-listing-heart"
        onClick={toggleFavourite}
        title="Remove from Favourites"
      />
    ) : (
      <Icon
        name="heart outline"
        size="big"
        color="grey"
        className="job-listing-heart"
        onClick={toggleFavourite}
        title="Add to Favourites"
      />
    );
  };

  const capitaliseDays = (days) => {
    return days
      .map((day) =>
        day
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      )
      .join(", ");
  };

  const getStepsV2 = () => {
    const steps = [
      {
        label: "Profile photo",
        path: "/",
        type: "all",
      },
      {
        label: "Work Location",
        path: "/PreferredWorkLocations",
        type: "all",
      },
      {
        label: "Address",
        path: "/personalDetails",
        type: "all",
      },
      {
        label: "ELT Certificate",
        path: "/resume",
        type: "elt",
      },
      {
        label: "Bachelor Degree",
        path: "/VocationalResume",
        type: "vet",
      },
      {
        label: "Qualifications",
        path: "/ececResume",
        type: "ecec"
      },
      {
        label: "Professional Experience",
        path: "/resume",
        type: "elt"
      },
      {
        label: "Professional Experience",
        path: "/ececResume",
        type: "ecec",
      },
      {
        label: "Industry Qualifications",
        path: "/VocationalResume",
        type: "vet",
      },
      { 
        label: "Industry Experience",
        path: "/VocationalResume",
        type: "vet",
      },
      {
        label: "WWCC",
        path: "/wwcc",
        type: "all"
      },
      {
        label: "First Aid (compulsory for ECEC)",
        path: "/ececcheck",
        type: "ecec",
      },
      {
        label: "USI (not compulsory)",
        path: "/usiCheck",
        type: "all",
      },
      {
        label: "Police Check (not compulsory)",
        path: "/policeCheck",
        type: "all",
      },
      {
        label: "Other Experience - VET (not compulsory)",
        path: "/VocationalResume",
        type: "vet",
      },
      {
        label: "Other Experience (not compulsory)",
        path: "/ececResume",
        type: "ecec",
      },
      {
        label: "Other Experience - ELT (not compulsory)",
        path: "/resume",
        type: "elt",
      },
      {
        label: "Can Deliver",
        path: "/",
        type: "all",
      },
      {
        label: "Upload Level Evidence",
        path: "/uploadPayLevel",
        type: "elt",
      },
      {
        label: "Reference Check",
        path: teacher?.is_elt
          ? "/resume"
          : (teacher?.is_vet ? "/VocationalResume" : "/ececResume"),
        type: "all",
      },
      {
        label: "Attend Onboarding Session",
        path: "https://www.readyteacherco.com/attend-onboarding",
        type: "all",
      },
    ];

    if (teacher?.is_childhood_teacher) {
      return steps.filter((step) => (step.type === "ecec" || step.type === "all") && step.label !== "Can Deliver")
    }

    if (teacher?.is_vet && teacher?.is_elt) {
      return steps.filter((step) => step.type === "elt" || step.type === "vet" || step.type === "all")
    }

    if (teacher?.is_vet) {
      return steps.filter((step) => step.type === "vet" || step.type === "all")
    }

    return steps.filter((step) => step.type === "elt" || step.type === "all")
  }

  const getStepsDataV2 = (user) => {
    const updateActiveStep = (step) => {
      step.active = true
      step.completed = true
    }
  
    const data = getStepsV2().map((step) => {
      step.active = false
      step.completed = false

      switch(step.label) {
        case "Profile photo":
          if (user.img_url) {
            updateActiveStep(step)
          }
          break;
        case "Work Location":
          if (user?.preferred_city1 && user?.preferred_country1) {
            updateActiveStep(step)
          }
          break;
        case "Address":
          if (user?.country && user?.state && user?.city && (user?.address_line1 || user?.address_line2)) {
            updateActiveStep(step)
          }
          break;
        case "ELT Certificate":
          if (user?.qualifications && user.qualifications.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "Bachelor Degree":
          if (user?.vet_training_quals && user.vet_training_quals.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "Qualifications":
          if (user?.qualifications && user.qualifications.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "Professional Experience":
          if (user?.professional_experience && user.professional_experience.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "Industry Qualifications":
          if (user?.vet_industry_quals && user.vet_industry_quals.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "Industry Experience":
          if (user?.vet_industry_exp && user.vet_industry_exp.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "WWCC":
          if (user?.wwcc_filename && user?.wwcc_issuing_state) {
            updateActiveStep(step)
          }
          if (user?.is_childhood_teacher) {
            step.label = "WWCC (compulsory for ECEC)"
          }
          break;
        case "First Aid (compulsory for ECEC)":
          if(user?.ecec_filename && user?.ecec_url) {
            updateActiveStep(step)
          }
          break;
        case "USI (not compulsory)":
          if (user?.usi_downloaded_date && user?.usi_filename) {
            updateActiveStep(step)
          }
          break
        case "Can Deliver":
          if (user?.selected_can_delivers && user.selected_can_delivers.length > 0) {
            updateActiveStep(step)
          }
          break
        case "Police Check (not compulsory)":
          if (user?.police_check_type && user?.police_check_result) {
            updateActiveStep(step)
          }
          break
        case "Other Experience (not compulsory)":
          if (user?.non_teaching_experience && user?.non_teaching_experience.length > 0) {
            updateActiveStep(step)
          }
          break
        case "Attend Onboarding Session":
          if (user?.is_onboarded) {
            updateActiveStep(step)
          }
          break
        case "Upload Level Evidence":
          if (user?.pay_level?.status === "accepted") {
            updateActiveStep(step)
          }
          break
        case "Reference Check":
          if (user?.referees && user.referees.length > 0) {
            updateActiveStep(step)
          }
          break
      }

      return { ...step }
    })

    return data
  }

  const getProgress = () => {
    let progress = 0;
    const steps = getStepsDataV2(teacher);

    for (var i = 0; i < steps.length; i++) {
      if (steps[i].active) {
        progress += 1;
      }
    }
    progress = (progress / steps.length) * 100;
    return progress;
  };

  return (
    <div className="job-listing-outer">
      {(isOwnListing || isAdmin) && (
        <div className="d-flex flex-wrap justify-content-start pt-0 pb-3">
          <Icon
            name="arrow left"
            size="large"
            className="back-to-listings"
            onClick={() =>
              props.history.push(
                isAdmin ? "/CollegeDetailListings" : "/MyListings"
              )
            }
            text={`Back to ${isOwnListing ? "My " : ""}Listings`}
            // title="Back to My Listings"
            data-tip={`Back to ${isOwnListing ? "My " : ""}Listings`}
          />
        </div>
      )}
      <div
        className={
          "job-card-container " + (isApplied ? "job-card-applied" : "")
        }
      >
        <div className="job-listing-header mb-1">
          <div className="job-listing-logo-container">
            <img
              className="job-listing-logo"
              src={inst.logo}
              alt={inst.institution_name + " logo"}
            />
          </div>
          <div className="job-listing-header-contents">
            <h1 className="job-listing-name">{job.title} </h1>
            {job.is_vet && (
              <h3
                className="job-listing-inst-name"
                name="course-code-show"
                data-tip={"Course codes: " + job.course_code}
              >
                {job.qual_name}
                <span className="job-listing-name">
                  {" "}
                  {" (See course codes)"}
                  <ReactTooltip
                    backgroundColor="rgb(47, 224, 222)"
                    className="coursecode-tooltip"
                    data-tip={job.course_code}
                  />
                </span>
              </h3>
            )}
            <div className="d-flex flex-wrap align-items-center">
              <h3 className="job-listing-inst-name">{inst.institution_name}</h3>
              {job.org_pro_visible && (
                <Link
                  to={"/NavigateToCollegeSharedProfile?id=" + inst._id}
                  target="blank"
                >
                  <span className="job-card-tag job-listing-view-inst-profile">
                    <Icon
                      name="share"
                      size="small"
                      color="white"
                    // className='job-listing-icon'
                    />
                    View Profile
                  </span>
                </Link>
              )}
            </div>
          </div>
          <div className="job-listing-options">
            <div className="w-50 mr-2">
              {(isViewAsTeacher || isPreview || isPublic) && (
                <div className="w-100 mt-3">
                  {isApplied ? interviewScheduleInfo ? (
                    <ConfirmButton
                    onClick={() => setShowInterviewPopup(true)}
                    // disabled={confirmedInterview}
                  >
                    {confirmedInterview ? "Confirmed Interview Time" : "Choose Interview Time"}
                  </ConfirmButton>) : (
                    <ConfirmButton disabled>Already Applied</ConfirmButton>
                  ) : (
                    <ConfirmButton
                      disabled={props.hasClosedDatePassed}
                      onClick={sendApplication}
                    >
                      {props.hasClosedDatePassed
                        ? "Application Closed"
                        : isPublic
                          ? "Apply with ReadyTeacher"
                          : "Apply for Job"}
                    </ConfirmButton>
                  )}
                </div>
              )}
              {
                _.isEmpty(teacher) && !isCustomer && (
                  <div className="w-100 mt-3">
                    <Link to="/Login">
                    <ConfirmButton>
                    Apply for Job
                  </ConfirmButton>
                    </Link>
                  </div>
                )
              }
            </div>
            <div className="d-flex align-items-center">
              <Icon
                name="share"
                size="big"
                className="job-listing-share"
                onClick={() => setShowPopup(true)}
                text="Share Job"
                // title="Share Profile"
                data-tip="Share Job"
                circular
                inverted
              />
              {(isViewAsTeacher || isPreview) && favHeart()}
            </div>
          </div>
        </div>
        <div className="job-card-container-inner job-listing-inner">
          <div className="mb-1">
            {job.selected_tags.map((tag) => {
              return (
                <span className="job-card-tag" key={tag}>
                  {getTagName(tag)}
                </span>
              );
            })}
          </div>
          <div className="d-flex flex-wrap align-items-center">
            <span className="job-listing-detail mb-0">
              <Icon
                name="clock outline"
                size="small"
                className="job-listing-icon"
              />
              <span className="job-listing-label">Posted:</span>{" "}
              <Moment format="DD MMM YYYY">{job.pub_date}</Moment>
            </span>
            <span className="job-listing-detail mb-0">
              <Icon
                name="exclamation circle"
                size="small"
                className="job-listing-icon"
              />
              <span className="job-listing-label">Applications Close:</span>{" "}
              <Moment format="DD MMM YYYY">{job.close_date}</Moment>
            </span>
            <span className="job-listing-detail mb-0">
              {!!job.no_of_roles && (
                <span className="job-listing-detail">
                  <Icon name="users" size="small" className="job-listing-icon" />
                  <span className="job-listing-label">Positions Available:</span>{" "}
                  {job.no_of_roles}
                </span>
              )}
            </span>
          </div>

          <div className="d-flex flex-wrap align-items-center mt-2">

            {!!campus.campus_shortname && (
              <span className="job-listing-detail">
                <Icon
                  name="map marker alternate"
                  size="small"
                  className="job-listing-icon"
                />
                <span className="job-listing-label">Location:</span>{" "}
                {job._id === "63ce1dcc4586226bef68eb11"
                  ? "Melbourne, Sydney, Brisbane, Adelaide"
                  : (job.various_campus ? 'Various' : campus.campus_shortname + ", " + campus.suburb)}
              </span>
            )}
            {!!campus.timezone && (
            <span className={job._id === "63ce1dcc4586226bef68eb11" ? "d-none" : "job-listing-detail"}>
              <span className="job-listing-label">Timezone:</span>{" "}
               {campus.timezone} 
            </span>
            )}

            <span className="job-listing-detail">
              <Icon name="building" size="small" className="job-listing-icon" />
              <span className="job-listing-label">Delivery Mode:</span>{" "}
              {job.delivery_mode
                ? getFullDeliveryModeString(job.delivery_mode)
                : job.online
                  ? "Online"
                  : "On campus"}
            </span>

            <span className="job-listing-detail">
              <Icon name="currency" size="small" className="job-listing-icon" />
              {job.salary_display_option ? (
                <>
                  <span className="job-listing-label">Salary:</span>{" "}
                  {job.salary_display_option}
                </>
              ) : job.hourly_rate_unit ? (
                <>
                  <span className="job-listing-label">Hourly Rate:</span> $
                  {job.hourly_rate_min}-${job.hourly_rate_max} $
                  {job.hourly_rate_unit}/hour {props.institution?.superannuation ? "+ Superannuation" : "" }
                </>
              ) : (
                <>
                  <span className="job-listing-label">Annual Rate:</span> $
                  {job.salary_min}-${job.salary_max} ${job.salary_unit}/year {props.institution?.superannuation ? "+ Superannuation" : "" }
                </>
              )}
            </span>

            <span className="job-listing-detail">
              <Icon name="clock" size="small" className="job-listing-icon" />
              <span className="job-listing-label">Schedule:</span>{" "}
              {job._id === "63ce1dcc4586226bef68eb11"
                ? capitaliseDays(job.days)
                : job.weekly_hours + " hours/week (" + capitaliseDays(job.days) + ")"}
            </span>

            <span className={job._id === "63ce1dcc4586226bef68eb11" ? "d-none" : "job-listing-detail"}>
              <Icon
                name="calendar alternate"
                size="small"
                className="job-listing-icon"
              />
              <span className="job-listing-label">Contract Period:</span>{" "}
              {
                job.display_various_dates ? 
                <>
                  Various start dates throughout the year - 12-24 months contract length
                </> : <>
                <Moment format="DD MMM YYYY">{job.start_date}</Moment> -{" "}
                <Moment format="DD MMM YYYY">{job.end_date}</Moment>
                </>
              }
            </span>
          </div>
          <hr className="search-card-hr mb-3" />
          <div className="job-listing-section">
            <h3 className="job-listing-subheading">Role Description</h3>
            <p className="job-listing-content newlines">{job.description}</p>
          </div>
          <div className="w-100 row">
            {!!job.responsibilities.length && (
              <div className="col-lg-4 column-fix">
                <div className="job-listing-section">
                  <h3 className="job-listing-subheading">Responsibilities</h3>
                  <ul className="job-listing-ul">
                    {job.responsibilities.map((resp, index) => {
                      return (
                        <li key={index} className="job-listing-list-item">
                          <span className="job-listing-icon">&#9679;</span>
                          <span className="job-listing-content">{resp}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            )}

            {!!job.benefits.length && (
              <div className="col-lg-4 column-fix">
                <div className="job-listing-section">
                  <h3 className="job-listing-subheading">Benefits</h3>
                  <ul className="job-listing-ul">
                    {job.benefits.map((ben, index) => {
                      return (
                        <li key={index} className="job-listing-list-item">
                          <span className="job-listing-icon">&#9679;</span>
                          <span className="job-listing-content">{ben}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            )}

            {!!job.expertise && !!job.expertise.length && (
              <div className="col-lg-4 column-fix">
                <div className="job-listing-section">
                  <h3 className="job-listing-subheading">
                    Required Expertise / Qualifications
                  </h3>
                  <ul className="job-listing-ul">
                    {job.expertise.map((exp, index) => {
                      return (
                        <li key={index} className="job-listing-list-item">
                          <span className="job-listing-icon">&#9679;</span>
                          <span className="job-listing-content">{exp}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            )}
          </div>

          {(isViewAsTeacher || isPreview || isPublic) && (
            <div className="w-100 mt-3">
              {isApplied ? interviewScheduleInfo ? (
                <ConfirmButton
                onClick={() => setShowInterviewPopup(true)}
                // disabled={confirmedInterview}
              >
                {confirmedInterview ? "Confirmed Interview Time" : "Choose Interview Time"}
              </ConfirmButton>) : (
                <ConfirmButton disabled>Already Applied</ConfirmButton>
              ) : (
                <ConfirmButton
                  disabled={props.hasClosedDatePassed}
                  onClick={sendApplication}
                >
                  {props.hasClosedDatePassed
                    ? "Application Closed"
                    : isPublic
                      ? "Apply with ReadyTeacher"
                      : "Apply for Job"}
                </ConfirmButton>
              )}
            </div>
          )}
          {
            _.isEmpty(teacher) && !isCustomer && (
              <div className="w-100 mt-3">
                <Link to="/Login">
                <ConfirmButton>
                Apply for Job
              </ConfirmButton>
                </Link>
              </div>
            )
          }
        </div>
      </div>

      <Modal
        className="schedule-interview-modal"
        header="Complete Your Profile"
        show={showProgressModal}
        onClose={() => setShowProgressModal(false)}
      >
        <div className="d-flex justify-content-center align-items-center">
          <p className="text-center">Please complete at least 50% of your profile before applying.</p>
        </div>
        <div style={{padding: '1rem'}}>
          <Link to="/Dashboard">
            <ConfirmButton>
                Go to Dashboard
            </ConfirmButton>
          </Link>
        </div>
      </Modal>

      <Modal
        className="schedule-interview-modal"
        header="Interview Time"
        show={showInterviewPopup}
        onClose={() => setShowInterviewPopup(false)}
      >
        {confirmedInterview ?
          <div className="row m-0">
            <CheckableButton
              className='w-100 mb-3 pl-5 p-2'
              checked={true}
            >
              {confirmedInterview.preferred_time
                ? new Date(confirmedInterview.preferred_time).toString()
                : "I don’t wish to attend an interview for this role."}
              <br/>
              {confirmedInterview.preferred_location === 'on_campus'
                ? "Location: " + confirmedInterview.campus
                : confirmedInterview.preferred_location === 'online'
                  ? "Meeting Link: " + confirmedInterview.meeting_link : null}
            </CheckableButton>
          </div>
          :
          <div className="row m-0">
            {interviewScheduleInfo?.map((item) => (
              <CheckableButton
                id={item._id}
                className='w-100 mb-3 pl-5 p-2'
                onChange={(e) => setInterviewTimeID(e.target.id)}
                checked={interviewTimeID === item._id}
              >
                {item.preferred_time
                  ? new Date(item.preferred_time).toString() : "I don’t wish to attend an interview for this role."}
                <br/>
                {item.preferred_location === 'on_campus'
                  ? "Location: " + item.campus
                  : item.preferred_location === 'online' ? "Meeting Link: " + item.meeting_link : null}
              </CheckableButton>
            ))}

            <ConfirmButton
              type="button"
              className='mt-3'
              onClick={confirmInterviewTime}
            >
              Confirm
            </ConfirmButton>
          </div>
        }
      </Modal>
      {/* </Link> */}
      {/* <div className="job-listing-options">
        <Icon
          name="share"
          circular
          inverted
          className="job-listing-share"
          size="big"
          onClick={() => setShowPopup(true)}
        />
        {(isViewAsTeacher || isPreview) && favHeart()}
      </div> */}
      {simpleQualificationsList?.length && (
        <ShareJobListing
          job={job}
          inst={inst}
          campus={campus}
          show={showPopup}
          onClose={() => setShowPopup(false)}
        />
      )}
      
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  addFavouriteListing: (listing_id) =>
    dispatch(addFavouriteListing(listing_id)),
  removeFavouriteListing: (listing_id) =>
    dispatch(removeFavouriteListing(listing_id)),
  updateSimpleQualification: (data) => dispatch(updateSimpleQualification(data))
});

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    simpleQualifications: state.user?.simpleQualifications || []
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(JobListingFull));
// export default connect(null, mapDispatchToProps)(JobListingFull);
